module.exports = __webpack_public_path__ + "media/img/pages/companies/bkw-200603115da19de3c0317739eecc79f2.png";